import { customerPortal } from "@vilocnv/allsetra-core";
import axiosInstance from "app/axiosInstance";

type PatchGeozoneRequestDto = customerPortal.geozones.PatchGeozoneRequestDto;

export const patchGeozone = async ({
  accountId,
  data
}: PatchGeozoneRequestDto) => {
  if (!accountId) return;

  const response = await axiosInstance.patch(
    `/accounts/${accountId}/geozones/${data.uniqueId}`,
    data
  );

  return response.data;
};
